'use strict';

var isUaWebview = require('is-ua-webview');
var AuthError = require('../errors/auth/AuthError.js');
var AuthWindowBlockedError = require('../errors/auth/AuthWindowBlockedError.js');
var AuthWindowClosedError = require('../errors/auth/AuthWindowClosedError.js');
var helpers = require('./helpers.js');
var subscriptions = require('./subscriptions.js');

/*
 * Helper for login by otac.
 * Solves problems: window modal size, window modal position, blocking window modal by browser.
 */
// deprecated  Use userManager
class AuthLoginByOtacHelper {
    params;
    _childWindow;
    constructor(params) {
        const { isWebview, ...rest } = params;
        this._childWindow = null;
        this.params = {
            isWebview: typeof isWebview === 'boolean' ? isWebview : this._getIsWebView(),
            ...rest,
        };
    }
    _getIsWebView() {
        if (typeof window === 'undefined')
            return;
        if (typeof window.navigator === 'undefined')
            return;
        const ua = window.navigator.userAgent;
        return isUaWebview(ua);
    }
    _getWindowFeatures(width, height) {
        const getSilentAuthModalPosition = (width, height) => {
            if (typeof window === 'undefined')
                return null;
            // Fixes dual-screen position                             Most browsers      Firefox
            const screenDualLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const screenDualTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
            const screenWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
            const screenHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
            const top = (screenHeight - height) / 2 + screenDualTop;
            const left = (screenWidth - width) / 2 + screenDualLeft;
            return {
                top,
                left,
            };
        };
        const modalPosition = getSilentAuthModalPosition(width, height);
        return `width=${width}, height=${height}, top=${modalPosition ? modalPosition.top : 0}, left=${modalPosition ? modalPosition.left : 0}`;
    }
    _getWindowParams() {
        const { type, width = 430, height = 600 } = this.params;
        const isNewWindow = ['modal', 'tab'].includes(type);
        const target = isNewWindow ? '_blank' : undefined;
        const features = ['modal'].includes(type) ? this._getWindowFeatures(width, height) : undefined;
        return {
            isNewWindow,
            target,
            features,
        };
    }
    _startChildWindowCloseWatcher(callback) {
        if (typeof window === 'undefined')
            return undefined;
        if (!this._childWindow)
            return undefined;
        return setInterval(() => {
            if (!this._childWindow ||
                this._childWindow.window === null ||
                this._childWindow.window === undefined ||
                this._childWindow.closed) {
                callback();
            }
        }, 500);
    }
    _startChildWindowTimeoutWatcher(timeout, callback) {
        if (typeof window === 'undefined')
            return undefined;
        if (!this._childWindow)
            return undefined;
        return setTimeout(() => {
            callback();
        }, timeout);
    }
    _loginByChildWindow(params) {
        if (typeof this._childWindow === 'undefined') {
            throw new Error('No window defined. Call method "prepare" first');
        }
        const { prefix, webPath, analytics: { productId } = {} } = this.params;
        const { otac, hint } = params;
        const { isNewWindow } = this._getWindowParams();
        const url = helpers.getLoginUrl({
            otac,
            hint,
            prefix,
            webPath,
            loginType: 'otac',
            isNewWindow,
            // Это нужно для логина под новым юзером, даже если мы уже залогинены под каким-то другим
            prompt: 'login',
            productId,
        });
        return new Promise((resolve, reject) => {
            const childWindowCloseWatcherId = this._startChildWindowCloseWatcher(() => {
                clearInterval(childWindowCloseWatcherId);
                reject(new AuthWindowClosedError.AuthWindowClosedError());
            });
            subscriptions.subscribeOnLoginSuccess(() => {
                clearInterval(childWindowCloseWatcherId);
                this.destroy();
                resolve();
            });
            subscriptions.subscribeOnLoginFailure(() => {
                clearInterval(childWindowCloseWatcherId);
                this.destroy();
                reject(new AuthError.AuthError());
            });
            if (this._childWindow) {
                this._childWindow.location.href = url;
                // Хак. не уверен что он работает
                this._childWindow.blur();
                setTimeout(this._childWindow.focus, 0);
            }
        });
    }
    _loginByRedirects(params) {
        const { prefix, webPath, analytics: { productId } = {} } = this.params;
        const { otac, hint } = params;
        const url = helpers.getLoginUrl({
            otac,
            hint,
            prefix,
            webPath,
            loginType: 'otac',
            // Это нужно для логина под новым юзером, даже если мы уже залогинены под каким-то другим
            prompt: 'login',
            productId,
        });
        window.location.href = url;
        return Promise.resolve(); // Для единого выходного интерфейса
    }
    /*
     * Must be called AFTER user action and BEFORE long js task (like ajax request)
     */
    prepare(params) {
        if (typeof window === 'undefined')
            return;
        if (this.params.isWebview)
            return;
        const { timeout = 10000, onError } = params || {};
        const { window: { title = 'Вход на сайт | Сравни.ру' } = {}, prefix, webPath } = this.params;
        const { target, features } = this._getWindowParams();
        const loadingUrl = helpers.getLoadingUrl({ prefix, webPath, timeoutExpired: Date.now() + timeout });
        // Сафари ругается при исполнении этого кода - window.open внутри async
        // Сафари не дает открыть новое окно если функция 'prepare' лежит в обработчике события. ОТ этого спасает setTimeout
        return new Promise((resolve, reject) => {
            const childWindow = window.open(loadingUrl, target, features);
            if (!childWindow) {
                // Так как код выполняется в setTimeout - то выбрасывание исключения через throw не будет перехвачено try catch над методом prepare
                if (typeof onError === 'function') {
                    onError(new AuthWindowBlockedError.AuthWindowBlockedError());
                    return;
                }
                reject(new AuthWindowBlockedError.AuthWindowBlockedError());
                return;
            }
            this._childWindow = childWindow;
            this._childWindow.document.title = title;
            // Запускаем таймер на макс время открытия доп вкладки
            this._startChildWindowTimeoutWatcher(timeout, () => this.destroy());
            resolve();
            // Хак. не уверен что он работает
            window.blur();
            setTimeout(window.focus, 0);
        });
    }
    /*
     * Implements login and error handling
     */
    login(params) {
        if (typeof window === 'undefined')
            return Promise.resolve();
        const { isWebview } = this.params;
        if (isWebview)
            return this._loginByRedirects(params);
        return this._loginByChildWindow(params);
    }
    destroy() {
        if (typeof window === 'undefined')
            return undefined;
        // При вызове этого кода синхронно сафари на ios теряет указатель на this._childWindow
        // А при отложенном вызове он есть
        setTimeout(() => {
            if (!this._childWindow) {
                return undefined;
            }
            this._childWindow.close();
            this._childWindow = null;
        }, 0);
    }
}

exports.AuthLoginByOtacHelper = AuthLoginByOtacHelper;
//# sourceMappingURL=authLoginByOtacHelper.js.map
